import autocomplete from 'autocompleter'
import 'autocompleter/autocomplete.css'
import axios from 'axios'

// by default the name and id from source are used for dropdown
// application.js querySelectorAll pulls all elements with class autocomplete-field
//
//  Pass data in GON.autocomplete object by element id
//  The following items are valid data items
//  source:  sets the source of dropdown **REQUIRED
//  filters: array of filter objects
//      key: name of query parameter
//      id: id of element containing value to filter by
//  targets array of target objects
//      id: element id of target
//      type: possible values: "key" - receives key from item
//                        "text" receives label from item
//                        "hide", "show" does what it says on selection
//                        "fill" fills target with data attribute from source elem named in fill-var attr
//                        "custom" - calls customTarget function for that autocompleteId
//  options:  object with following possible values:
//        "clearOnEsc", "allowAdd"  presence indicates true
//        "displayField"  allows use of field other that name for dropdown label
//        "staticFilter" add static query params here
//
//

function customTarget(autocompleteId, target, item) {
  switch (autocompleteId) {
    case 'autocompleteSample':
      target.value = 'some special value:' + item.label
      break
    default:
      break
  }
}

function getDisplayText(labelText, delim) {
  return labelText.indexOf(delim) > 0 ? labelText.substr(0, labelText.indexOf(delim)) : labelText
}

function getTarget(targets, type) {
  let targetElement = null
  targets.some(function(t) {
    if (t.type == type) {
      targetElement = document.getElementById(t.id)
      return true
    }
  })
  return targetElement
}

function getExtraFilterParams(acFilters, staticFilters){
  var qStr = staticFilters ? '&' + staticFilters : ''
  if (acFilters){
    acFilters.forEach(filter => {
      let filterElem = document.getElementById(filter.id)
      if (filterElem && filterElem.value != null) {
        qStr += `&${filter.key}=${filterElem.value}`
      }
    })
  }
  return qStr
}

function clearTargets(acTargets){
  acTargets.forEach(target => {
    let targetElem = document.getElementById(target.id)
    switch (target.type) {
      case 'key':
        targetElem.value = null
        break
      case 'text':
        targetElem.value = ''
        break
      case 'fill':
        targetElem.value = null
        break
    }
  })
}

export function load_autocomplete(autocompleteEl) {
  const acId = autocompleteEl.id
  const ds = window.gon && window.gon.autocomplete && window.gon.autocomplete[acId]
  if (ds) { 
    const source = ds.source.charAt(0) === '/' ? ds.source : '/' + ds.source
    const acTargets = ds.targets || []
    const acFilters = ds.filters
    const hiddenTextEl = getTarget(acTargets, 'text')
    const acOptions = ds.options ? ds.options : {}
    const nameVar = acOptions.displayField ? acOptions.displayField : "name"
    const allowAdd = acOptions.allowAdd ? true : false
    const clearOnEsc = acOptions.clearOnEsc ? true : false
    const staticFilters = acOptions.filters

    if (clearOnEsc) {
      autocompleteEl.onkeydown = function (e) {
        if (e.key === "Backspace" || e.key === "Delete") {
          autocompleteEl.value = ''
          clearTargets(acTargets)

        }
        if (e.key == 13) {
          e.preventDefault()
        }
      }
    } else {
      autocompleteEl.onkeydown = function (e) {
        if (e.key === "Enter") {
          e.preventDefault()
        }
      }
    }

    autocomplete({
      input: autocompleteEl,
      debounceWaitMs: 200,
      minLength: 3,
      fetch: (text, update) => {
        if (allowAdd && hiddenTextEl) {
          hiddenTextEl.value = text
        }
        text = text.toLowerCase()
        const qStr = '.json?search=' + text + getExtraFilterParams(acFilters, staticFilters)
        axios.get(source + qStr)
          .then(resp => {
            update(resp.data.map(record => ({
              value: record.id,
              label: record[nameVar]
            })))
          })
      },
      onSelect: item => {
        autocompleteEl.value = acOptions.textDelim ? getDisplayText(item.label, acOptions.textDelim) : item.label
        acTargets.forEach(target => {
          var targetElem = document.getElementById(target.id)
          switch (target.type) {
            case 'key':
              targetElem.value = item.value
              break
            case 'text':
              targetElem.value = acOptions.textDelim ? getDisplayText(item.label, acOptions.textDelim) : item.label
              break
            case 'fill':
              targetElem.value = target.fillWith
              break
            case 'hide':
              targetElem.style.display = 'none'
              break
            case 'show':
              target.style.display = 'initial'
              break
            case 'custom':
              customTarget(acId, target, item)
              break
            default:
              break
          }
        })
      },
      render: item => {
        const itemElement = document.createElement('div')
        itemElement.textContent = item.label
        return itemElement
      }
    })
  }
}